import React, { useState } from "react";
import { MdEdit } from "react-icons/md";
import { FaTrashAlt } from "react-icons/fa";
import QuestionDetailForm from "../QuestionDetailForm/QuestionDetailForm";
import CreateQuestionForm from "../CreateQuestionForm/CreateQuestionForm";

function UserQuizQuestionsTable({
  questions,
  fetchQuizQuestions,
  createNewQuestion,
  setCreateNewQuestion,
  userData,
}) {
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [questionToDelete, setQuestionToDelete] = useState(null);

  const deleteQuestion = (questionId) => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/QuizQuestion/delete/${questionId}/user`,
      {
        method: "DELETE",
        credentials: "include",
      }
    ).then(() => {
      fetchQuizQuestions();
      alert("Question has been deleted!");
    });
  };

  const updateQuestion = (questionId, updatedData) => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/QuizQuestion/edit/${questionId}/user`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(updatedData),
      }
    ).then(() => {
      fetchQuizQuestions();
      alert("Question has been updated!");
    });
  };

  const createQuestion = (newData) => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/QuizQuestion/add`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(newData),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          fetchQuizQuestions();
          alert("Question has been added!");
        }
      });
  };

  return (
    <div className="table-wrapper">
      <table>
        <thead>
          <tr>
            <th style={{ width: "40px", textAlign: "center" }}>No.</th>
            <th>Question</th>
            <th>Type</th>
            <th>Score</th>
            <th style={{ width: "175px", textAlign: "center" }}>Roles</th>
            <th>Recommendations</th>
            <th style={{ width: "60px", textAlign: "center" }}>Enabled</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {questions.map((q, index) => (
            <tr key={q._id}>
              <td style={{ width: "40px", textAlign: "center" }}>
                {index + 1}
              </td>
              <td className="overflow-cell" title={q.questionText}>
                {q.questionText}
              </td>
              <td className="overflow-cell">{q.questionClass}</td>
              <td className="overflow-cell">{q.score}</td>
              <td className="overflow-cell" style={{ width: "175px" }}>
                <ul style={{ margin: 0, paddingLeft: "1.2em" }}>
                  {(q.visibleToRoles || []).map((role, i) => (
                    <li key={i}>{role}</li>
                  ))}
                </ul>
              </td>
              <td className="overflow-cell">
                <ul style={{ margin: 0, paddingLeft: "1.2em" }}>
                  {(q.recommendations || []).map((rec, i) => (
                    <li key={i}>{rec}</li>
                  ))}
                </ul>
              </td>
              <td style={{ width: "60px", textAlign: "center" }}>
                {q.enabled ? "✓" : "✗"}
              </td>
              <td>
                <button onClick={() => setSelectedQuestion(q)}>
                  <MdEdit />
                </button>
                <button
                  className="red-button"
                  onClick={() => setQuestionToDelete(q)}
                >
                  <FaTrashAlt />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Edit Modal */}
      {selectedQuestion && (
        <QuestionDetailForm
          question={selectedQuestion}
          onClose={() => setSelectedQuestion(null)}
          onSave={(updatedData) => {
            updateQuestion(selectedQuestion._id, updatedData);
            setSelectedQuestion(null);
          }}
        />
      )}

      {/* Delete Modal */}
      {questionToDelete && (
        <div className="modal">
          <div className="modal-content">
            <button
              className="modal-close"
              onClick={() => setQuestionToDelete(null)}
            >
              ×
            </button>
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete this question?</p>
            <p>
              <i>{questionToDelete.questionText}</i>
            </p>
            <div className="modal-buttons">
              <button
                className="red-button"
                onClick={() => {
                  deleteQuestion(questionToDelete._id);
                  setQuestionToDelete(null);
                }}
              >
                Delete
              </button>
              <button onClick={() => setQuestionToDelete(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {createNewQuestion && (
        <CreateQuestionForm
          defaultQuizType="user"
          onClose={() => setCreateNewQuestion(false)}
          onSave={(newData) => {
            createQuestion(newData);
            setCreateNewQuestion(false);
          }}
        />
      )}
    </div>
  );
}

export default UserQuizQuestionsTable;
